// import helpers from './helpers.js'

import DefaultSettings from '../../settings/default.settings.js'
import DevSettings from '../../settings/dev.settings.js'
import TestSettings from '../../settings/test.settings.js'
import ProductionSettings from '../../settings/production.settings.js'

function plugin(Vue, router) {
    // Exit if the plugin has already been installed.
    if (plugin.installed) return


    const Manager = new Vue({

        router,

        data() {
            return {
                env: buildEnv.env,
                settingsObject: {},
                userSettings: {},
                jwOptions: {},
                jwTempOptions: {},
                setupComplete: false,
                adDynamics: null,
                mounted: false,
            }
        },


        methods: {

            init() {
                this.$l.log('$manager: settings plugin init', buildEnv, this);

                // return;

                // Custom base64 encoded config parameter
                if (this.$route.query.o) {
                    try {
                        this.userSettings = JSON.parse(atob(this.$route.query.o))
                    }
                    catch (e) {
                        //
                    }
                }

                if(this.userSettings.environment) {
                    this.$l.log('$manager: getting settings from userSettings (o param)')
                    this.env = this.userSettings.environment
                }
                else if (this.$route.query.env) {
                    this.$l.log('$manager: getting settings from query param')
                    this.env = this.$route.query.env
                }

                this.settingsObject = DefaultSettings

                // Load Environment specific Settings
                switch (this.env) {
                    case 'dev':
                        this.$l.log('$manager: loading dev settings')
                        this.addSettings(DevSettings)
                        break

                    case 'test':
                        this.$l.log('$manager: loading test settings')
                        this.addSettings(TestSettings)
                        break

                    case 'production':
                        this.$l.log('$manager: loading production settings')
                        this.addSettings(ProductionSettings)
                        break

                    default:
                        this.$l.log('$manager: loading default settings')
                        break
                }

                this.addSettings(this.userSettings)

                // temporarily save jwOptions from Settings
                if (typeof(this.settingsObject.jwOptions) != 'undefined' && this.settingsObject.jwOptions != null) {
                    this.jwTempOptions = this.settingsObject.jwOptions
                }

                this.mounted = true
                this.$events.emit('settingsMounted', this.settingsObject)

                this.$l.log('$manager: settingsPluginMounted', this.settingsObject)
            },

            get(settingsPath) {
                return this.$helpers.getPropByString(this.settingsObject, settingsPath);
            },

            // add/overwrite Settings
            addSettings(settings) {
                this.settingsObject = this.$helpers.assign(this.settingsObject, settings)
            },

            addItemData(itemData) {
                this.$l.log('$manager: addItemData', itemData)
                this.$item = this.$helpers.assign(this.$item, itemData)
                this.$events.fire('newItemData', this.$item)
            },

            refreshStreamId() {
                this.$item = this.$helpers.assign(this.$item, {
                    streamId: this.$helpers.uuidv4()
                })

                this.$events.fire('newStreamId', this.$item)
            },

            // add/overwrite Options to temporary Option Object
            addOptions() {

                if (arguments.length > 1) {
                    //this.jwTempOptions[arguments[0]] = Object.assign({}, this.jwTempOptions[arguments[0]], arguments[1])
                    this.jwTempOptions[arguments[0]] = this.$helpers.assign(this.jwTempOptions[arguments[0]], arguments[1])
                }
                else {
                    // this.jwTempOptions = Object.assign({}, this.jwTempOptions, arguments[0])
                    this.jwTempOptions = this.$helpers.assign(this.jwTempOptions, arguments[0])
                }

            },

            // finalize the Options
            finalizeSetup() {

                this.$l.log('$manager: finalizeSetup')

                this.jwOptions = this.jwTempOptions
                this.setupComplete = true

                this.$events.emit('setupFinal', this.settingsObject)
            },


            // --- HELPER METHODS

            // add Playlist Option
            addPlaylist(playlist) {
                this.addOptions({
                    playlist: playlist
                })
            },

            vendorGrant(vendorId) {

                // instantly resolve if consent is not required
                if(this.get('consent.active') !== true) {
                    return Promise.resolve(true);
                }

                var vm = this;

                // Create a promise that rejects in <ms> milliseconds
                let timeout = new Promise((resolve, reject) => {
                    let id = setTimeout(() => {
                        clearTimeout(id);
                        resolve(false)
                    }, this.get('consent.timeout'))
                })

                let promise = new Promise(function(resolve, reject) {

                    window.addEventListener('message', function(event) {
                        if(event.data &&
                            event.data.action == 'vendorGrant' &&
                            event.data.hasOwnProperty('vendorId') &&
                            event.data.vendorId == vendorId
                        ) {
                            console.log("vendorGrant - receiving data", event.data);
                            resolve(event.data.grants);
                        }
                    });

                    window.parent.postMessage({
                        action: 'reqVendorGrant',
                        vendorId: vendorId
                    }, '*');


                });

                // Returns a race between our timeout and the passed in promise
                return Promise.race([
                    promise,
                    timeout
                ])

            },

            whenExperiment(flagKey) {

                // Create a promise that rejects in <ms> milliseconds
                let timeout = new Promise((resolve, reject) => {
                    let id = setTimeout(() => {
                        clearTimeout(id);
                        resolve(true)
                    }, 3000)
                })

                let promise = new Promise(function(resolve, reject) {

                    window.addEventListener('message', function(event) {
                        if(event.data &&
                            event.data.action == 'sendExperimentData' &&
                            event.data.hasOwnProperty(flagKey)
                        ) {
                            console.log("whenExperiment - receiving data", event.data);
                            resolve(event.data[flagKey]);
                        }
                    });

                    window.parent.postMessage({
                        action: 'reqExperimentData'
                    }, '*');


                });

                // Returns a race between our timeout and the passed in promise
                return Promise.race([
                    promise,
                    timeout
                ])
            }
        }

    });

    Manager.init();

    Object.defineProperty(Vue.prototype, '$manager', {
        get() {
            return Manager
        }
    })

    // Extend `Vue.prototype` to include our global event bus.
    Object.defineProperty(Vue.prototype, '$settings', {
        get() {
            return Manager.settingsObject;
        },
        // set (value) {
        //     settings = value
        // }
    })

}

export default {
    install: plugin
}



// WEBPACK FOOTER //
// ./src/plugins/manager/index.js